/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Cc_Position_Top_CenterInputs */



/**
* | output |
* | --- |
* | "Position Top Center" |
*
* @param {Shortcut_Keys_Name_Cc_Position_Top_CenterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_cc_position_top_center = /** @type {((inputs?: Shortcut_Keys_Name_Cc_Position_Top_CenterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Cc_Position_Top_CenterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Positionner en haut au centre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position Top Mitte")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione in alto al centro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позиция Верхний Центр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posición Centro Superior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("位置：顶部中心")
	if (locale === "ja") return /** @type {LocalizedString} */ ("上中央に配置する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शीर्ष केंद्र में स्थित")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição no centro superior")
	return /** @type {LocalizedString} */ ("Position Top Center")
});